<template>
  <div class="flex-col flex flex-1 w-full">
    <label
      v-if="label || $slots.label"
      class="label"
      :for="inputId"
    >
      <slot name="label">
        {{ label }}

        <span
          v-if="hint"
          class="tooltip has-tooltip-right has-tooltip-arrow no-underline"
          :data-tooltip="hint"
        >
          <i class="fas fa-info-circle text-info" />
        </span>
      </slot>
    </label>
    <input
      :id="inputId"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :inputmode="inputmode"
      :readonly="readonly"
      :class="{
        '!border-red-600 dark:border-red-500': isInvalid
      }"
      @input="$emit('input', $event.target.value)"
      v-on="datePicker ? { ...$listeners } : {}"
    >
    <div
      v-if="validation"
      class="h-2.5 text-red-600 dark:text-red-500 text-xs mb-3"
    >
      {{ errors[0]?.$message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputComponent',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    inputmode: {
      type: String,
      default: ''
    },
    pattern: {
      type: String,
      default: ''
    },
    validation: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    datePicker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputId() {
      return this.id || this.label.toLowerCase().replace(' ', '-');
    },
    isInvalid() {
      return this.errors[0]?.$message;
    }
  }
};
</script>

<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style lang="scss" scoped>

</style>
